// base
import { createContext } from 'react';

// providers
import { type ShowAlarmProps } from 'providers';

export interface AlarmContextProps {
  showAlarm: (props?: ShowAlarmProps) => void;
  closeAlarm: () => void;
}

export const AlarmContext = createContext<AlarmContextProps>({
  showAlarm: () => {},
  closeAlarm: () => {}
});
